<template>
  <modal class="modal cloudapp-modal narrow" id="login-modal" :hide-footer="true">
    <template #modal-header>
      <img :src="require('images/logo@2x.png')" class="logo" />
      <span class="title">Log in</span>
    </template>

    <div>
      <ul class="errors text-danger"></ul>
      <a href="#" class="cloudapp-btn white google-signup google-login-button" @click="authorizeGoogleOauth">
        <img width="19px" :src="require('images/google_logo.svg')" class="mr-2">
        <span>Log in with Google</span>
      </a>

      <a :href="appleIdUrl" class="btn apple-login-button btn-block btn-light">
        <img :src="require('images/apple_logo.svg')" class="mr-2">
        <span>Sign in with Apple </span>
      </a>

      <small class="form-text text-muted text-center">or</small>

      <form data-type="json" autocomplete="false" action="/api/v4/login" accept-charset="UTF-8" data-remote="true" method="post">
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" name="email" id="email" required="required" class="form-control" autocomplete="off" v-model="email">
          <small class="form-text text-muted">We'll never share your email with anyone else.</small>
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <input type="password" name="password" id="password" required="required" autocomplete="off" class="form-control" >
          <input value="web:viewer" type="hidden" name="source" id="source">
          <input :value="returnTo" type="hidden" name="redirect_to" id="redirect_to">
        </div>
        <div class="text-center">
          <input type="submit" name="commit" value="Log in" data-disable-with="Log in" class="cloudapp-btn blue identifyUser create-account">
        </div>
      </form>
    </div>

    <div id="no-account">
      <a href="/sso/new?utm_campaign=login_modal&utm_source=viewer">Sign in with SSO</a>
      <p class="have-an-account">
        Don't have a CloudApp account?
        <a href="#" @click="trackAndOpenLogin" data-testid="signup-link" class="cloudapp-link primary">
          <span> Sign up </span><i class="fas fa-arrow-right"></i>
        </a>
      </p>
    </div>
  </modal>
</template>

<script>
import track from '@/src/tracking';
import authorizeGoogleOauth from '@/src/google_oauth';
import { modalsUser } from "@/src/observable";


export default {
  props: {
    returnTo: String
  },
  methods: {
    trackAndOpenLogin: function(){
      track('login_to_signup_viewer');
      this.$bvModal.hide('login-modal');
      this.$bvModal.show('signup-modal');
    },
    authorizeGoogleOauth: authorizeGoogleOauth
  },
  computed: {
    email: {
      set: function(val){ modalsUser.email = val },
      get: function(){ return modalsUser.email }
    },
    appleIdUrl: () => `/auth/apple?web=true&return_to=${window.location.href}`
  }
}
</script>

<style lang="scss">
  @import '../../packs/application.scss';

  #login-modal___BV_modal_outer_ {
    .modal-content { overflow: hidden; }

    .modal-dialog {
      width: 380px;
    }

    .modal-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .logo {
        height: 27px;
        margin-right: 9px;
      }

      .title {
        font-size: 1.4rem;
        font-weight: 600;
      }
    }

    .modal-body {
      background: $white-three;

      form {
        label {
          font-size: 12px;
          font-weight: 600;
        }
      }

      #no-account {
        border-top: 1px solid #dee2e6;
        margin-top: 1.25rem;
        padding: 1.25rem;
        text-align: center;
      }
    }
  }
</style>